export default {
    formId: 'customerForm',
    formField: {
        first_name: {
            name: 'first_name',
            label: 'First name',
            placeholder: 'First name',
            requiredErrorMsg: 'Please provide your first name',
            invalidErrorMsg: 'Please provide your first name'
        },
        last_name: {
            name: 'last_name',
            label: 'Last name',
            placeholder: 'Last name',
            requiredErrorMsg: 'Please provide your last name',
            invalidErrorMsg: 'Please provide your last name'
        },
        email: {
            name: 'email',
            label: 'Email Address',
            placeholder: 'mail@mail.com',
            invalidErrorMsg: 'Please provide a valid email address',
            requiredErrorMsg: 'Please provide a valid email address'
        },
        mobile_phone: {
            name: 'mobile_phone',
            label: 'Mobile Number',
            invalidErrorMsg: 'Please provide a valid mobile number',
            invalidPattern: 'Your phone number cannot start with 0 or 1',
            requiredErrorMsg: 'Please provide a valid mobile number'
        },
        tcpa: {
            name: 'tcpa',
            label: 'Check this box to consent to receiving autodialed calls and texts to your mobile phone number. TCPA Consent'
        },
        terms: {
            name: 'terms',
            requiredErrorMsg: 'Please select the checkbox'
        },
        date_of_birth_1i: {
            name: 'date_of_birth_1i',
            label: 'Year',
            invalidErrorMsg: 'Please provide a valid year',
            requiredErrorMsg: 'Please provide a valid year'
        },
        date_of_birth_2i: {
            name: 'date_of_birth_2i',
            label: 'Month',
            invalidErrorMsg: 'Please provide a valid month',
            requiredErrorMsg: 'Please provide a valid month'
        },
        date_of_birth_3i: {
            name: 'date_of_birth_3i',
            label: 'Day',
            invalidErrorMsg: 'Please provide a valid day',
            requiredErrorMsg: 'Please provide a valid day'
        },
        street_address: {
            name: 'street_address',
            label: 'Street Address',
            requiredErrorMsg: 'Please provide a valid street address',
            invalidErrorMsg: 'Please provide a valid street address'
        },
        street_address2: {
            name: 'street_address2',
            label: 'Apt/Suite (If Applicable)'
        },
        fullStreet: {
            name: 'full_Street',
            label: 'Street Address',
            requiredErrorMsg: 'Please provide a valid street address',
            invalidErrorMsg: 'Please provide a valid street address'
        },
        city: {
            name: 'city',
            label: 'City',
            invalidErrorMsg: 'Please provide your city',
            requiredErrorMsg: 'Please provide your city'
        },
        state: {
            name: 'state',
            label: 'State',
            requiredErrorMsg: 'Please select a state'
        },
        pay_period: {
            name: 'pay_period',
            label: 'How often do you receive income?',
            requiredErrorMsg: 'Please select your income frequency'
        },
        income_source: {
            name: 'income_source',
            label: 'Income Source',
            requiredErrorMsg: 'Please select your income source'
        },
        income_source_description: {
            name: 'income_source_description',
            label: 'Income Source Description',
            requiredErrorMsg: 'Please select your income source description '
        },
        monthly_income: {
            name: 'monthly_income',
            label: 'How much do you receive after taxes per paycheck?',
            requiredErrorMsg: 'Please provide your income after taxes'
        },
        employer: {
            name: 'employer',
            label: 'Employer Name',
            requiredErrorMsg: 'Please provide your employer name'
        },
        other_income: {
            name: 'other_income',
            label: 'Income Source Description',
            requiredErrorMsg: 'Please provide your income source description'
        },
        income_type: {
            name: 'income_type',
            label: 'How do you receive income?',
            requiredErrorMsg: 'Field is required'
        },
        work_phone: {
            name: 'work_phone',
            label: 'Employer Phone',
            invalidErrorMsg: 'Your phone number should be 10 digits long, e.g. (555) 555-5555',
            invalidPattern: 'Your phone number cannot start with 0 or 1',
            requiredErrorMsg: 'Please provide a valid employer phone number'
        },
        other_income_phone: {
            name: 'other_income_phone',
            label: 'Income Source Phone Number',
            invalidErrorMsg: 'Your phone number should be 10 digits long, e.g. (555) 555-5555',
            invalidPattern: 'Your phone number cannot start with 0 or 1',
            requiredErrorMsg: 'Please provide your income source phone number'
        },
        zip_code: {
            name: 'zip_code',
            label: 'ZIP Code',
            requiredErrorMsg: 'Please provide a valid  ZIP code',
            invalidErrorMsg: 'Please provide a valid  ZIP code'
        },
        ssn: {
            name: 'ssn',
            label: 'SSN',
            requiredErrorMsg: 'Please provide a valid SSN',
            invalidErrorMsg: 'Please provide a valid SSN'
        },
        drivers_license_number: {
            name: 'drivers_license_number',
            label: 'Driver\'s License Number or State ID',
            requiredErrorMsg: 'Please provide a valid driver\'s license number or state ID'
        },
        drivers_license_state: {
            name: 'drivers_license_state',
            label: 'Driver\'s License State or State ID State',
            requiredErrorMsg: 'Please select a state'
        },
        active_military: {
            name: 'active_military',
            label: 
            // eslint-disable-next-line max-len
            'Are you a servicemember or a servicemember’s dependent covered by the Military Lending Act? <sup>&dagger;</sup>',
            requiredErrorMsg: 'Field is required'
        },
        first_pay_date: {
            name: 'first_pay_date',
            label: 'Paycheck 1',
            requiredErrorMsg: 'Please select a date',
            invalidErrorMsg: 'Paycheck 1 is not valid'
        },
        second_pay_date: {
            name: 'second_pay_date',
            label: 'Paycheck 2',
            requiredErrorMsg: 'Please select a date',
            invalidErrorMsg: 'Paycheck 2 is not valid'
        },
        pay_date_after_next: {
            name: 'pay_date_after_next',
            label: 'Future paycheck',
            requiredErrorMsg: 'Please select a date',
            invalidErrorMsg: 'Future paycheck is not valid'
        },
        loan_amount: {
            name: 'loan_amount',
            label: 'Desired loan amount',
            // eslint-disable-next-line  no-template-curly-in-string
            placeholder: '${{minLoanAmount}} min - ${{maxLoanAmount}} max',
            // eslint-disable-next-line  no-template-curly-in-string
            requiredErrorMsg: 'Please enter an amount between ${{minLoanAmount}} and ${{maxLoanAmount}}'
        },
        bank_routing_number: {
            name: 'bank_routing_number',
            label: 'Routing Number',
            requiredErrorMsg: 'Please provide a valid routing number',
            invalidErrorMsg: 'Please provide a valid routing number'
        },
        bank_account_number: {
            name: 'bank_account_number',
            label: 'Account Number',
            requiredErrorMsg: 'Please provide a valid account number',
            invalidErrorMsg: 'Please provide a valid account number'
        },
        marital_status: {
            name: 'marital_status',
            label: 'What is your marital status?',
            requiredErrorMsg: 'Field is required'
        },
        spouse_first_name: {
            name: 'spouse_first_name',
            label: 'Spouse first name',
            placeholder: 'James',
            requiredErrorMsg: 'Please provide your spouse’s name',
            invalidErrorMsg: 'Please provide your spouse’s name'
        },
        spouse_last_name: {
            name: 'spouse_last_name',
            label: 'Spouse last name',
            placeholder: 'Smith',
            requiredErrorMsg: 'Please provide your spouse’s last name',
            invalidErrorMsg: 'Please provide your spouse’s last name'
        },
        spouse_email: {
            name: 'spouse_email',
            label: 'Spouse email',
            placeholder: 'mail@mail.com',
            invalidErrorMsg: 'Please provide a spouse\'s email',
            requiredErrorMsg: 'Please provide a spouse\'s email'
        },
        is_same_home_address: {
            name: 'is_same_home_address',
            label: 'Does your spouse have the same home address as you?',
            requiredErrorMsg: 'Field is required'
        },
        spouse_street_address: {
            name: 'spouse_street_address',
            label: 'Spouse\'s Street Address',
            requiredErrorMsg: 'Please provide a valid street address',
            invalidErrorMsg: 'Please provide a valid street address'
        },
        spouse_address2: {
            name: 'spouse_address2',
            label: 'Apt/Suite (If Applicable)'
        },
        spouseFullStreet: {
            name: 'spouseFullStreet',
            label: 'Spouse\'s home Street Address',
            requiredErrorMsg: 'Please provide a valid street address',
            invalidErrorMsg: 'Please provide a valid street address'
        },
        spouse_city: {
            name: 'spouse_city',
            label: 'City',
            invalidErrorMsg: 'Please provide your spouse city',
            requiredErrorMsg: 'Please provide your spouse city'
        },
        spouse_state: {
            name: 'spouse_state',
            label: 'State',
            requiredErrorMsg: 'Please select a state'
        },
        spouse_zip: {
            name: 'spouse_zip',
            label: 'ZIP Code',
            requiredErrorMsg: 'Please provide a valid  ZIP code',
            invalidErrorMsg: 'Please provide a valid  ZIP code'
        }
    }
};
